<template>
	<div class="hierarchy-header tw-px-16 tw-py-6">
		<div class="header-title">
			<h3 class="uppercase tw-m-0">Jerarquía de Puestos</h3>
		</div>
		<ol class="steps tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-m-0 tw-p-0">
			<li class="step">
				<span class="step-number">1</span>
				<span class="step-label">Clic en el puesto jefe</span>
			</li>
			<li class="step-separator" aria-hidden="true">→</li>
			<li class="step">
				<span class="step-number">2</span>
				<span class="step-label">Activa las casillas <span class="check-glyph">✓</span> de sus subordinados en el organigrama</span>
			</li>
			<li class="step-separator" aria-hidden="true">→</li>
			<li class="step">
				<span class="step-number">3</span>
				<span class="step-label">Cierra el panel</span>
			</li>
			<li class="step-separator" aria-hidden="true">→</li>
			<li class="step">
				<span class="step-number">4</span>
				<span class="step-label">Genera el organigrama</span>
			</li>
		</ol>
		<p class="mirror-note tw-m-0">
			Si un puesto ya tiene otro jefe, usa el icono
			<v-icon size="16" class="mirror-note-icon">device_hub</v-icon>
			para mostrarlo también en esta área.
		</p>
	</div>
</template>

<script>
export default {
	name: 'job-hierarchy-header',
};
</script>

<style lang="scss" scoped>
.hierarchy-header {
	.header-title {
		text-align: center;
		margin-bottom: 12px;
		h3 {
			font-size: 18px;
			color: var(--app-color-primary);
		}
	}
	.steps {
		list-style: none;
		.step {
			display: inline-flex;
			align-items: center;
			.step-number {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 22px;
				height: 22px;
				border-radius: 50%;
				border: 1px solid var(--app-color-primary);
				color: var(--app-color-primary);
				font-size: 12px;
				font-weight: bold;
				margin-right: 8px;
				flex-shrink: 0;
			}
			.step-label {
				font-size: 13px;
				color: var(--app-color-info);
				line-height: 1.3;
				.check-glyph {
					color: var(--app-color-primary);
					font-weight: bold;
				}
			}
		}
		.step-separator {
			color: #969696;
			margin: 0 12px;
			font-size: 14px;
		}
	}
	.mirror-note {
		margin-top: 10px;
		font-size: 12px;
		color: #f09c2b;
		text-align: center;
		.mirror-note-icon {
			color: var(--app-color-secondary) !important;
			vertical-align: middle;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-hierarchy-header.vue